module.exports = __webpack_public_path__ + "img/62073b1.jpg";